import React from 'react';
import { pain } from '../data/content';
export function PainPoints() {
  return <section className="bg-parchment-deep text-ink" data-id="element-154" data-mp="2ln2iag3shpt6">
      <div className="mx-auto grid max-w-content gap-10 px-5 py-14 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16 lg:py-24" data-id="element-155" data-mp="2lmsrwreu1gmy">
        <div className="text-center lg:self-center lg:text-left" data-id="element-156" data-mp="26wlggvn8sxvr">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl lg:text-[2.4rem]" data-id="element-157" data-mp="2bvy2xfa7c2xt">
            {pain.headline}
          </h2>
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-ink-soft sm:text-lg lg:mx-0" data-id="element-158" data-mp="220e8yyf77ebp">
            {pain.intro}
          </p>
        </div>

        <div data-id="element-159" data-mp="1syer63wd067p">
          <ul className="border-t border-parchment-line" data-id="element-160" data-mp="1sy4zmbvo1qzw">
            {pain.situations.map(item => <li key={item.title} className="flex gap-4 border-b border-parchment-line py-4 sm:py-5" data-id="element-161" data-mp="3idbi01gq11j1">
                <span aria-hidden="true" className="mt-2.5 h-2 w-2 flex-none rounded-full bg-leaf" data-id="element-162" data-mp="3nalc3uf221d7" />
                <p className="font-sans text-[1.05rem] leading-relaxed text-ink-soft" data-id="element-163" data-mp="1u0ivwwoyxgrc">
                  <span className="font-semibold text-ink" data-id="element-164" data-mp="27ticz34efj10">{item.title}</span>{' '}
                  {item.description}
                </p>
              </li>)}
          </ul>

          <p className="mt-8 text-center font-display text-2xl font-semibold leading-snug text-gold-deep sm:text-[1.75rem] lg:text-left" data-id="element-165" data-mp="1g1j4xidzgps0">
            {pain.close}
          </p>
        </div>
      </div>
    </section>;
}